const monthNames = [
    'Января',
    'Февраля',
    'Марта',
    'Апреля',
    'Мая',
    'Июня',
    'Июля',
    'Августа',
    'Сентября',
    'Октября',
    'Ноября',
    'Декабря',
];

export default (iso) => {
    // const dateServer = new Date();
    // dateServer.setTime(parseInt(timestamp) * 1000);
    // const dateString = dateServer.toISOString();
    const date = new Date(iso);
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    let month = date.getMonth();
    const day = date.getDate();

    month = monthNames[month].toLowerCase();
    return `${day} ${month}, ${hours}:${minutes}`;
};
